(function() {
    'use strict';

    angular.module('page')
        .directive('cpInputUiSelectLayout', cpInputUiSelectLayout);

    cpInputUiSelectLayout.$inject = [];

    function cpInputUiSelectLayout() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/page/directives/input-ui-select-layout/input-ui-select-layout.html',
            scope: {
                object: '=',
                prop: '@',
                options: '=?',
                isRequired: '=?',
                isDisabled: '=?',
                isMultiple: '=?',
                onChange: '&?',
                optionPropTitle: '@',
                optionPropValue: '@'
            },
            link: function(scope, element, attrs, controller) {}
        };
    }
})();
